const settings = {
    timeFunction: (timeRatio) => timeRatio ** 2,
    progressFunction: (timeFunction, timeRatio) => (
        timeRatio < 0.5
            ? timeFunction(2 * timeRatio) / 2
            : (2 - timeFunction(2 * (1 - timeRatio))) / 2),
    duration: 500,
    dY: 15,
};

function fadeByProgress(progress, element, fade) {
    // eslint-disable-next-line no-param-reassign
    element.style.transform = `translateY(${fade === 'fadeIn' ? (1 - progress) * settings.dY : progress * settings.dY}px)`;
    // eslint-disable-next-line no-param-reassign
    element.style.opacity = fade === 'fadeIn' ? progress * 1 : (1 - progress) * 1;
}

function animation(start, element, fade, delay = 0, callback) {
    const { timeFunction, progressFunction, duration } = settings;

    function animate(time) {
        const timeRatio = time - start >= delay ? (time - (start + delay)) / duration : 0;
        const progress = progressFunction(timeFunction, timeRatio);

        fadeByProgress(progress, element, fade);

        if (timeRatio < 1) {
            requestAnimationFrame(animate);
        } else if (callback) callback();
    }
    requestAnimationFrame(animate);
}

function fadeAnimation(ref = null, fade, delay, callback = null) {
    if (ref) {
        const element = ref.current;
        const start = performance.now();

        animation(start, element, fade, delay, callback);
    }
}

export default fadeAnimation;
